import React, { Component } from "react";
import Titulo from "../../../generico/TituloPagina";
import DatosSocio from "../../../generico/DatosSocio";
import DataTable from "react-data-table-component";
import Popup from "react-popup";
import history from "../../login/history";
import { trackPromise } from "react-promise-tracker";
import ConfigService from "../../../../services/configuracion/ConfigService";
import SubsidioService from "../../../../services/solicitudes/SubsidiosService";
import AvisoGeneral from "../../../generico/AvisoGeneral";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";


const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true,
};

export default class Subsidio extends Component {
  constructor(props) {
    super(props);
    this.getListaSubsidios = this.getListaSubsidios.bind(this);
    this.cuenta = React.createRef();
    this.state = {
      subsidios: undefined,
      columnas: this.getColumn(),
      tieneArchivosRechazados: false,
    };
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  componentDidMount() {
    this.getListaSubsidios();
  }

  initState() {
    this.setState({
      subsidios: undefined,
      columnas: this.getColumn(),
    });
  }

  getListaSubsidios() {
    let respuesta = [];
    trackPromise(
      SubsidioService.obtenerSubsidioSocio().then((response) => {
        let data = JSON.stringify(response.data);
        let jsonData = JSON.parse(data);
        //console.log(jsonData);
        if (jsonData.codigo === 0) {
          // let indice = 0;
          let archivosRechazados = false;
          for (let i = 0; i < jsonData.datos.length; i++) {
            respuesta.push({
              nroSolicitud: jsonData.datos[i].identificador,
              cuentaAhorro: jsonData.datos[i].idAhorro,
              tipoSubsidio: jsonData.datos[i].tipoSubsidioDescripcion,
              claseSubsidio: jsonData.datos[i].claseSubsidioDescripcion,
              idClaseSubsidio: jsonData.datos[i].claseSubsidio,
              fechaHecho: jsonData.datos[i].fechaHecho,
              fechaPresentacion:
                jsonData.datos[i].fechaPresentacion !== null
                  ? jsonData.datos[i].fechaPresentacion
                  : "----",
              estado: jsonData.datos[i].estadoDescripcion,
              estadoID: jsonData.datos[i].estado,
            });
            if (+jsonData.datos[i].estado === 10) archivosRechazados = true;
          }
          this.setState({
            subsidios: respuesta,
            expandir: false,
            tieneArchivosRechazados: archivosRechazados,
          });
        } else {
          Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
          return;
        }
      })
    );
    return this.state.subsidios;
  }

  getColumn(tieneRechazados = false) {
    let columnas = [
      {
        name: "Número Solicitud",
        center: true,
        selector: row => row.nroSolicitud,
      },
      {
        name: "Cuenta Ahorro",
        center: true,
        selector: row => row.cuentaAhorro,
      },
      {
        name: "Tipo Subsidio",
        selector: row => row.tipoSubsidio,
        width: "150px",
      },
      {
        name: "Clase Subsidio",
        selector: row => row.claseSubsidio,
        width: "150px",
      },
      {
        name: "Fecha Hecho",
        selector: row => row.fechaHecho,
        center: true,
        width: "120px",
      },
      {
        name: "Fecha Presentación",
        selector: row => row.fechaPresentacion,
        center: true,
        width: "120px",
      },
      {
        name: "Estado",
        selector: row => row.estado,
      },
    ];

    if (tieneRechazados) {
      columnas.push({
        minWidth: "200px",
        center: true,
        cell: (row) =>
          +row.estadoID === 10 && (
            <button
              className="btn btn-cu-primary btn-sm"
              param={row}
              onClick={() => {
                history.push({ pathname: "/modificarSubsidio", state: row });
                window.location.reload();
              }}
            >
              <i className="fas fa-info-circle" />
              <span> Actualizar Archivos</span>
            </button>
          ),
      });
    }
    return columnas;
  }

  agregarSubsidio = (e) => {
    history.push(ConfigService.getPathByName("agregarSubsidio")?.url);
    window.location.reload();
  };

  refrescarListaSubsidio = (e) => {
    history.push(ConfigService.getPathByName("solicitudSubsidios")?.url);
    window.location.reload();
  };

  render() {
    if (this.state.subsidios === undefined) this.getListaSubsidios();

    return (
      <div className="content-wrapper">
        <Titulo texto="Solicitud de Subsidios" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                    <div className="col-lg-10 col-md-8"><DatosSocio /></div>
                    <div className="col-lg-2 col-md-4">
                    <button
                          className="btn btn-cu-secundary"
                          onClick={this.agregarSubsidio}
                        >
                        <FontAwesomeIcon icon={faPlus} />   Agregar Subsidio
                        </button>
                        <button
                          hidden
                          className="btn btn-cu-secundary"
                          style={{ marginRight: 5 }}
                          onClick={this.refrescarListaSubsidio}
                        >
                          Inicio
                        </button>
                    </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <label className="input-label-bold">Subsidios</label>
                    {this.state.tieneArchivosRechazados && <AvisoGeneral />}
                    <div className="row mt-3">
                      <div className="col-md-12">
                        <div className="table-responsive">
                          <DataTable
                            noHeader={true}
                            pagination={true}
                            columns={this.getColumn(
                              this.state.tieneArchivosRechazados
                            )}
                            data={this.state.subsidios}
                            // dense={true}
                            paginationComponentOptions={paginationOptions}
                            noDataComponent="no hay registros para mostrar"
                            striped={true}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <i className="fas fa-redo" style={{fontSize:"30px",color:"#007c34"}}></i> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
